/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

// @ is an alias to /src

export default {
    name: 'Error',
    data() {
        return {
            'check': this.Constants.STATUS_CONFIRMED
        }
    }
}
